const middleware = {}

middleware['activities'] = require('../../../middleware/activities.ts')
middleware['activities'] = middleware['activities'].default || middleware['activities']

middleware['authenticated'] = require('../../../middleware/authenticated.ts')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['background-style'] = require('../../../middleware/background-style.ts')
middleware['background-style'] = middleware['background-style'].default || middleware['background-style']

middleware['centers'] = require('../../../middleware/centers.ts')
middleware['centers'] = middleware['centers'].default || middleware['centers']

middleware['children'] = require('../../../middleware/children.ts')
middleware['children'] = middleware['children'].default || middleware['children']

middleware['expenses'] = require('../../../middleware/expenses.ts')
middleware['expenses'] = middleware['expenses'].default || middleware['expenses']

middleware['income'] = require('../../../middleware/income.ts')
middleware['income'] = middleware['income'].default || middleware['income']

middleware['parents'] = require('../../../middleware/parents.ts')
middleware['parents'] = middleware['parents'].default || middleware['parents']

middleware['unauthenticated'] = require('../../../middleware/unauthenticated.ts')
middleware['unauthenticated'] = middleware['unauthenticated'].default || middleware['unauthenticated']

export default middleware
